package com.anjuros.website.templates.template4.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import com.anjuros.website.components.shared.AnjurosBackgroundImage
import com.anjuros.website.components.shared.AnjurosLogo
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.MenuIcon
import com.anjuros.website.templates.template4.components.Template4Header
import com.anjuros.website.templates.template4.modules.Template4Theme
import com.anjuros.website.templates.template4.modules.getColor
import com.anjuros.website.templates.template4.styles.Template4MainHeightStyle
import com.anjuros.website.templates.template4.styles.Template4MainTextStyle
import com.anjuros.website.templates.template4.util.ResKey
import com.anjuros.website.templates.template4.util.Template4CompanyDetails
import com.anjuros.website.templates.template4.util.Template4Constants
import com.anjuros.website.templates.template4.util.Template4Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template4MainSection(
    modifier: Modifier = Modifier.fillMaxWidth(),
    onMenuClosed:()->Unit ={}){
    Box(
        modifier = modifier
            .id("home")
            .fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        Box(modifier = Modifier.size(50.px).displayUntil(Breakpoint.LG).align(Alignment.TopStart)){

            MenuIcon(
                modifier = Modifier

                    .align(Alignment.Center)
                    .color(Template4Theme.Primary.getColor())
                    .onClick { onMenuClosed() }
            )
        }
        Template4MainContent(Modifier.align(Alignment.TopCenter))
    }
}

@Composable
fun Template4MainContent(modifier: Modifier){

    val breakPoint = rememberBreakpoint()
    val animatedMargin= remember { mutableStateOf(100.px) }
    val animatedOpacity= remember { mutableStateOf(0.0f) }

    val scope = rememberCoroutineScope()
    LaunchedEffect(breakPoint) {
        scope.launch {
            delay(300)
            animatedMargin.value=0.px
            animatedOpacity.value=1.0f

        }
    }



    Column(modifier = modifier.fillMaxWidth().margin(top=30.px),
        horizontalAlignment = Alignment.CenterHorizontally){
        Box {
            AnjurosLogo(
                modifier = Modifier.size(70.px),
                src = Template4Res.Image.template4_logo,
                alt = "Professional web design for sole traders UK"
            )
        }

        Box(modifier = Modifier.margin(top=20.px)){
            P(
                attrs = Modifier
                    .align(Alignment.Center)
                    .margin(leftRight = 5.px)
                    .align(Alignment.Center)
                    .fontFamily(Template4Constants.FONT_FAMILY)
                    .fontSize(24.px)
                    .color(Template4Theme.Secondary.rgb)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs()
            ) {
                AnjurosText(Template4CompanyDetails.CLIENTS_COMPANY_INFO)

            }
        }
        Box(modifier = Modifier.margin(top=10.px)){
            Link(path =
            "tel:${Template4Constants.CLIENTS_PHONE}",
                modifier = Modifier.textDecorationLine(TextDecorationLine.None)) {
                P(
                    attrs = Modifier
                        .align(Alignment.Center)
                        .margin(leftRight = 5.px)

                        .align(Alignment.Center)
                        .fontFamily(Template4Constants.FONT_FAMILY)
                        .fontSize(20.px)
                        .color(Template4Theme.DarkGrey.rgb)
                        .fontWeight(FontWeight.Normal)
                        .toAttrs()
                ) {
                    AnjurosText(Template4CompanyDetails.CLIENTS_PHONE_INFO)

                }
            }
        }

        Template4Header()
        Box (modifier = Template4MainHeightStyle
            .toModifier()
            .fillMaxWidth()
            .margin(top=10.px)) {

            AnjurosBackgroundImage(
                src=Template4Res.Image.template4_main,
                alt="main",
                modifier = Template4MainHeightStyle
                    .toModifier()
                    .fillMaxWidth()
                    .objectFit(ObjectFit.Fill)
            )
            P(
                attrs = Template4MainTextStyle.toModifier()
                    .align(Alignment.Center)
                    .textAlign(TextAlign.Center)
                    .margin(top=animatedMargin.value, left=10.px, right=10.px)
                    .opacity(animatedOpacity.value)
                    .transition(Transition.of(property = "margin", duration = 1500.ms),
                        Transition.of(property = "opacity", duration = 1000.ms))
                    .transition()
                    .align(Alignment.Center)
                    .fontFamily(Template4Constants.FONT_FAMILY)
                    .color(Template4Theme.DarkGrey.rgb)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs()
            ) {
                Text(LocalText(ResKey.TEMPLATE4_SLOGAN1))

            }
        }
    }
}